import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import PropTypes from "prop-types";
import MDButton from "../../MDButton";
import { CircularProgress, Modal } from "@mui/material";
import { getShift } from "../../../actions/shift/shift";
import { getDefects } from "../../../actions/defect/defect";

ModalDefect.propTypes = {
  showModal: PropTypes.any,
  setShowModal: PropTypes.any,
  setData: PropTypes.any,
  onSelectedIdsChange: PropTypes.any,
};
export default function ModalDefect({ showModal, setShowModal, setData, onSelectedIdsChange }) {
  const [loading, setLoading] = useState(true);
  const [machines, setMachines] = useState({ data: [] });
  const [selectAll, setSelectAll] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);

  async function getDefect(term) {
    setLoading(true);
    const data = await getDefects(term);
    if (data.message.data.length === 0) {
      setShowModal(false);
      toast.warning("نقص فنی یافت نشد");
      return;
    }
    setMachines(data.message);
    setLoading(false);
  }

  useEffect(() => {
    if (showModal) {
      getDefect(setData);
    }
  }, [showModal]);

  const handleSelectAllChange = (e) => {
    const isChecked = e.target.checked;
    setSelectAll(isChecked);

    if (isChecked) {
      const allIds = machines.data.map((item) => item.id);
      setSelectedIds(allIds);
    } else {
      setSelectedIds([]);
    }
  };

  function clickButton() {
    console.log(selectedIds);
  }

  const handleCheckboxChange = (id, isChecked) => {
    const updatedSelectedIds = isChecked
      ? [...selectedIds, id]
      : selectedIds.filter((selectedId) => selectedId !== id);

    setSelectedIds(updatedSelectedIds);
    if (updatedSelectedIds.length === machines.data.length) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  };
  return (
    <>
      {showModal ? (
        <>
          <Modal open={showModal} onClose={()=>{setShowModal(false)}} className="justify-center w-auto items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="w-full relative my-6 mx-auto max-w-3xl">
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col bg-white outline-none focus:outline-none">
                <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
                  <h3 className="text-2xl font-semibold">انتخاب نقص فنی</h3>
                  <button
                    className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={() => setShowModal(false)}
                  >
                    <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                      ×
                    </span>
                  </button>
                </div>
                {loading ? (
                  <div className="flex p-6 flex-auto justify-center items-center">
                    <CircularProgress size={30} color={"info"}/>
                  </div>
                ) : (
                  <div>
                    <div className="pt-5 mx-4 flex items-center">
                      <input
                        id="MainContent_chkNoeDas"
                        type="checkbox"
                        name="ctl00$MainContent$chkNoeDas"
                        className="mr-2 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                        checked={selectAll}
                        onChange={handleSelectAllChange}
                      />
                      <label
                        htmlFor="MainContent_chkNoeDas"
                        className="mx-1 text-gray-700 dark:text-white"
                      >
                        همه موارد
                      </label>
                    </div>
                    <div className="flex p-6 flex-auto justify-start items-start">
                      <div className="w-full overflow-y-auto h-52">
                        <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                          <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                            <tr>
                              <th scope="col" className="">
                                <div className="flex items-center"></div>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {machines.data.map((item, index) => (
                              <tr
                                key={index}
                                className={`bg-white ${
                                  index !== machines.data.length - 1 ? "border-b border-gray" : ""
                                } dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600`}
                              >
                                <td className="w-4 p-4">
                                  <div className="flex items-center">
                                    <input
                                      id={`checkbox-table-search-${index}`}
                                      type="checkbox"
                                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                                      checked={selectedIds.includes(item.id)}
                                      onChange={(e) =>
                                        handleCheckboxChange(item.id, e.target.checked)
                                      }
                                    />
                                    <label
                                      htmlFor={`checkbox-table-search-${index}`}
                                      className="sr-only"
                                    >
                                      checkbox
                                    </label>
                                  </div>
                                </td>
                                <th
                                  scope="row"
                                  className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                                >
                                  {item.id}
                                </th>
                                <td className="px-6 py-4">{item.title}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )}
                {/*footer*/}
                <div className="gap-5 flex items-center justify-start p-6 border-t border-solid border-blueGray-200 rounded-b">
                  <MDButton
                    color={"info"}
                    className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={() => {
                      onSelectedIdsChange(selectedIds);
                      setShowModal(false);
                    }}
                  >
                    انتخاب
                  </MDButton>
                  <MDButton
                    color={"error"}
                    className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={() => setShowModal(false)}
                  >
                    انصراف
                  </MDButton>
                </div>
              </div>
            </div>
          </Modal>
        </>
      ) : null}
    </>
  );
}
